var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMtgBooster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-140 -30 217 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlLang: "en",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "card",
    width: 63,
    height: 88,
    rx: 2,
    fill: "inherit"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#card",
    transform: "translate(-125, -50) rotate(0)",
    fill: "#368b20"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#card",
    transform: "translate(-90, -52) rotate(10)",
    fill: "#c01b1b"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#card",
    transform: "translate(-50, -45) rotate(20)",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#card",
    transform: "translate(-10, -30) rotate(30)",
    fill: "#dadab4"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#card",
    transform: "translate(22, -10) rotate(40)",
    fill: "#1e22e6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtgBooster);
export default __webpack_public_path__ + "static/media/mtg-booster.26870f1826a160af7fc50f9751913d74.svg";
export { ForwardRef as ReactComponent };